<script>
export default {
  name: 'UlFormNumber',
  props: {
    value: {
      type: Number,
    },
    min: {
      type: Number,
      default: -Infinity,
    },
    max: {
      type: Number,
      default: Infinity,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    btn: {
      type: String,
      default: 'max',
    },
  },
  data: () => ({
    show: false,
  }),
  computed: {
    elInput() {
      return this.$el.querySelector('input');
    },
    classes() {
      return {
        'ul-form-number--max': this.btn === 'max',
        'ul-form-number--min': this.btn === 'min',
      };
    },
  },
};
</script>
<template>
  <div class="ul-form-number" :class="classes">
    <el-input-number
      :value="value"
      :disabled="disabled"
      :max="max"
      :min="min"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
      @keypress.enter="$emit('change', $event)"
    />
  </div>
</template>
<style lang="scss">
  .ul-form-number {
    position: relative;

    .el-input-number {
      display: flex;
      line-height: 0;
      width: 100%;

      .el-input__inner {
        background: none;
        border: none;
        height: 28px;
        font-size: 16px;
        padding: 0;
        flex-grow: 1;
        order: 1;
        text-align: left;
      }

      .el-input {
        order: 1;
        flex: 1;
      }

      .el-input-number__decrease {
        order: 2;
      }

      .el-input-number__increase {
        order: 3;
      }

      .el-input-number__decrease,
      .el-input-number__increase {
        display: none;
        height: 26px;
        width: 26px;
        left: 0;
        right: 0;
        border: none;
        background: none;
        position: relative;
        margin: 0 2px;
        border-radius: 50%;

        &:hover {
          &:hover {
            background-color: rgba(0, 0, 0, 0.05);
          }

          &:active {
            background-color: rgba(0, 0, 0, .1);
          }

          &:focus {
            background-color: rgba(0, 0, 0, .12);
          }
        }
      }
    }

    i {
      line-height: 26px;
    }

    &--max {
      .el-input-number {
        .el-input-number__decrease,
        .el-input-number__increase {
          display: block;
        }
      }
    }

    &--min {
      .el-input-number {
        .el-input-number__decrease,
        .el-input-number__increase {
          width: 16px;
          border-radius: 4px;
          display: block;
        }
      }
    }
  }
</style>
